export const getEnvironment = () => {
  const { hostname } = window.location;
  let environment;

  switch (hostname) {
    case 'localhost':
    case 'www.localhost':
    case '127.0.0.1':
      environment = 'development';
      break;
    case 'dev.themens.com.br':
    case 'www.dev.themens.com.br':
    case 'hml.consultoriomedico.digital':
      environment = 'development';
      break;
    case 'themens.com.br':
    case 'www.themens.com.br':
    case 'consultoriomedico.digital':
    case 'www.consultoriomedico.digital':
      environment = 'production';
      break;
    default:
      environment = 'production';
  }

  return environment;
};